import {ArtfactKind, EnvironmentKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';
import moment from 'moment';

@HookClass('mind')
export class MindHook extends BaseHook {

    @Hook('7ae86d3b-2b3b-4df0-bc1d-adfc18caed2a')
    public learnDocumentAndApplyModel(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://mind.local.nickbuilder.com.br/api/process/start/new/client/default'
                            : 'https://mind.fluna.io/api/process/start/new/client/default';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/7ae86d3b-2b3b-4df0-bc1d-adfc18caed2a`,
                                params: {},
                                headers: {
                                    'nick-system': '76194205-459d-45a4-b3ea-7b5f6583a4e0',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('77cce4d6-0b15-425e-b8d6-90c3961a9e37')
    public startCompleteMind(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://mind.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://mind.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/77cce4d6-0b15-425e-b8d6-90c3961a9e37`,
                                params: {},
                                headers: {
                                    'nick-system': '5812687f-65f8-4c95-9b5e-277eb5337bca',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('7af46982-e441-41a8-97ef-2962d1f0c84e')
    public completeMind(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://mind.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://mind.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/dd6fc487-d0b8-4376-a6da-6c9829be18dc`,
                                params: {},
                                headers: {
                                    'nick-system': '5812687f-65f8-4c95-9b5e-277eb5337bca',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('8c6e4b60-4a3f-48a2-88d8-73b08cf6171c')
    public readDocument(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://mind.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://mind.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8c6e4b60-4a3f-48a2-88d8-73b08cf6171c`,
                                params: {},
                                headers: {
                                    'nick-system': '5812687f-65f8-4c95-9b5e-277eb5337bca',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('4a62eb7b-6a6d-4c4b-b654-2ef43e6e131d')
    public processAttributes(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://mind.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://mind.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/8c6e4b60-4a3f-48a2-88d8-73b08cf6171c`,
                                params: {},
                                headers: {
                                    'nick-system': '5812687f-65f8-4c95-9b5e-277eb5337bca',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

    @Hook('d5bd043c-2961-49cd-8e0e-07c5499e8161')
    public uploadDocument(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.make<HttpHook>(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => {
                return this.settings
                    .pipe(concatMap((settings: any) => {

                        const endpoint = settings.environment == EnvironmentKind.DEV
                            ? 'https://mind.local.nickbuilder.com.br/api/process/start/new'
                            : 'https://mind.fluna.io/api/process/start/new';


                        const httpArtifact = new NickProcessArtfact();
                        httpArtifact.kind = ArtfactKind.ANY;
                        httpArtifact.object = {
                            config: {
                                url: `${endpoint}/d5bd043c-2961-49cd-8e0e-07c5499e8161`,
                                params: {},
                                headers: {
                                    'nick-system': '5812687f-65f8-4c95-9b5e-277eb5337bca',
                                    'authorization': this.context.token
                                },
                                body: inputArtifact.object
                            }
                        };

                        return httpHook.postExternal(httpArtifact);
                    }));
            }))
            .pipe(map((response: NickProcessArtfact) => {
                return response;
            }));
    }

}

